import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Column } from 'seagull';
import { AttachmentFile } from './AttachmentFile';
import { AttachmentsTestIds } from './Attachments.utils';
import { AttachmentTitle } from './AttachmentTitle';
export const Attachments = (param)=>{
    let { files, onRemove, disableDownloadLinks } = param;
    if (files.length === 0) return /*#__PURE__*/ _jsx(_Fragment, {});
    return /*#__PURE__*/ _jsxs("div", {
        "data-testid": AttachmentsTestIds.Root(),
        children: [
            /*#__PURE__*/ _jsx(AttachmentTitle, {}),
            /*#__PURE__*/ _jsx(Column, {
                children: files.map((file, index)=>/*#__PURE__*/ _jsx(AttachmentFile, {
                        disableDownloadLink: disableDownloadLinks,
                        file: file,
                        index: index,
                        onRemove: onRemove
                    }, file.id))
            })
        ]
    });
};
